/* Dosimira 2026-10-22: WhatsApp teslimat sonrası mesajındaki "Yorum" butonu ürün sayfasını ?yorum=1 ile açar.
   Bu durumda sayfa Judge.me yorum bölümüne kayar ve "Değerlendirme yazın" formunu kendiliğinden açar.
   Parametre yoksa hiçbir şey yapmaz. Judge.me bileşeni geç yüklendiği için ~15 sn boyunca tekrar dener. */
(function () {
  if (!/[?&]yorum=1(&|$)/.test(location.search)) return;
  var tries = 0;
  function openReviewForm() {
    var widget = document.querySelector('.jdgm-widget.jdgm-review-widget, #judgeme_product_reviews');
    var btn = widget && widget.querySelector('button.jm-button--primary, .jdgm-write-rev-link');
    if (btn) {
      btn.scrollIntoView({ block: 'center' });
      btn.click();
      return;
    }
    if (widget && tries % 4 === 0) widget.scrollIntoView({ block: 'center' });
    if (++tries < 60) setTimeout(openReviewForm, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openReviewForm);
  } else {
    openReviewForm();
  }
})();
